import HttpClienteToken from '../../services/HttpClientToken';

import { TipoUsuarioProps } from '../../interfaces/catalogos/TipoUsuarioInterface';

export const TipoUsuarios = () => {

    return new Promise<TipoUsuarioProps[]>( (resolve, eject) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){
            const { token } = data;

            HttpClienteToken.get('/Api/TipoUsuario/', token)
            .then( ({ data } : { data : TipoUsuarioProps[] } ) => {               
                resolve( data );                
            })
            .catch( () => {
                resolve( [] );
            });
        }

    });

}

export const ObtenerTipoUsuarios = () => {

    return new Promise<TipoUsuarioProps[]>( (resolve, eject) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){
            const { token } = data;

            HttpClienteToken.get('/Api/TipoUsuario/ObtenerTipoUsuarios', token)
            .then( ({ data } : { data : TipoUsuarioProps[] } ) => {               
                resolve( data );                
            })
            .catch( () => {
                resolve( [] );
            });
        }

    });

}

export const ActualizarTipoUsuario = ( params: TipoUsuarioProps ) => {

    return new Promise<TipoUsuarioProps>( (resolve, eject) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){
            const { token } = data;

            HttpClienteToken.post('/Api/TipoUsuario/Actualizar', params, token)
            .then( ({ data } : { data : TipoUsuarioProps} ) => {               
                resolve( data );                
            })
            .catch( () => {
                resolve( {
                    idTipoUsuario: 0,                 
                    descripcion: '',
                    activo: false,     
                });
            });
        }

    });

}

export const AgregarTipoUsuario = ( params: TipoUsuarioProps ) => {

    return new Promise<TipoUsuarioProps>( (resolve, eject) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){
            const { token } = data;

            HttpClienteToken.post('/Api/TipoUsuario/Agregar', params, token)
            .then( ({ data } : { data : TipoUsuarioProps} ) => {               
                resolve( data );                
            })
            .catch( () => {
                resolve( {
                    idTipoUsuario: 0,
                    descripcion: '',
                    activo: false,    
                });
            });
        }

    });

}